import {useEffect, useState} from "react";
import {BreadCrumbs} from "../../../components/open/pages";
import {useParams} from "react-router-dom";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, PostJSON, ServerImage} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {
    CheckIcon, ThinCalendarIcon,
    ThinDocumentIcon,
    ThinEditIcon,
    ThinEditNoteIcon,
    ThinFamilyLoveIcon,
    ThinIdCardIcon,
    ThinInfoIcon,
    ThinnerPeopleIcon, ThinTimeIcon
} from "../../../components/icons/material-icons";
import {AdminsStaffHireAddEditJobModal} from "./hire-add-job-modal";
import {CurrencyFormat, StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {GregorianToPersian} from "../../../components/techaran/date-convert";
import '../../../static/css/pages/staff/hire.css';
import {AdminsHireSignupViewNoteModal} from "./hire-view-signup-note";
import {ShowSnackbar} from "../../../components/template/snackbar";

interface requestInterface {
    id: number,
    name: string,
    tell: string,
    gender: string,
    soldier: string,
    isMarried: boolean,
    cv: string,
    photo: string,
    createdAt: string,
    notes: string,
    reviewed: boolean,
    workNotes:string,
    birthDate:string,
    yearsActive:number,
}

export const AdminsHireViewJobScreen = () => {
    const [data, setData] = useState({
        loaded: false,
        title: '',
        cert: '',
        desc: '',
        needed: 0,
        isTaken: false,
        createdAt: '2000-01-01 00:00:00',
    });
    const [signups, setSignups] = useState<requestInterface[]>([]);
    const {jobId} = useParams();
    const fetchData = () => {
        PostJSON(
            Apis.server + '/core/admins/staff/careers/job/get',
            {
                job: jobId,
            },
            true,
            (d: {
                result: string,
                reason: string,
                title: string,
                cert: string,
                desc: string,
                needed: number,
                isTaken: boolean,
                createdAt: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setData({
                    loaded: true,
                    cert: d.cert,
                    createdAt: d.createdAt,
                    desc: d.desc,
                    isTaken: d.isTaken,
                    needed: d.needed,
                    title: d.title,
                });
                document.title = d.title + " | فرصت‌های شغلی | شهاب";
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        fetchData();
    }, []);
    const [editModal, setEditModal] = useState(false);
    const [tab, setTab] = useState('info' as 'info' | 'signups');
    const fetchRequests = () => {
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/staff/careers/signups/list',
            {
                job: jobId,
            },
            true,
            (d: {
                result: string,
                reason: string,
                list: requestInterface[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setSignups(d.list === null ? [] : d.list);
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        const t = tab;
        if (t === 'signups')
            fetchRequests();
    }, [tab]);
    const [noteModal, setNoteModal] = useState({
        show: false,
        name: '',
        note: '',
    });
    const [workNotesModal, setWorkNotesModal] = useState({
        show: false,
        name: '',
        note: '',
    });
    const setAsReviewed = (id:number) => {
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/staff/careers/signups/review',
            {
                id:id.toString(),
            },
            true,
            (d: {
                result: string,
                reason: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                ShowSnackbar(
                    "وضعیت درخواست تغییر یافت.",
                    'باشه',
                    5000,
                );
                ShowProgressLoading();
                fetchRequests();
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    return (
        <>
            <BreadCrumbs links={[
                {url: '/admins', title: 'اتوماسیون'},
                {url: '/admins/staff', title: 'منابع انسانی'},
                {url: '/admins/staff/hire', title: 'فرصت‌های شغلی'},
                {url: `/admins/staff/hire/view/${jobId}`, title: data.loaded ? data.title : '...'},
            ]}/>
            <div className="container" data-aos={"fade-up"} data-aos-duration={1000}>
                <div className="open-tabbar" style={{marginTop: 20}}>
                    <div className="open-tabbar-inner">
                        <button onClick={() => {
                            setTab('info');
                            window.scrollTo({top: 0, behavior: 'smooth'});
                        }} className={tab === 'info' ? 'active' : ''}>
                            <ThinInfoIcon/>
                            مشخصات
                        </button>
                        <button onClick={() => {
                            setTab('signups');
                            window.scrollTo({top: 0, behavior: 'smooth'});
                        }} className={tab === 'signups' ? 'active' : ''}>
                            <ThinnerPeopleIcon/>
                            درخواست ها
                        </button>
                    </div>
                </div>
                {
                    tab === 'info' ?
                        <div className="row justify-content-center">
                            <div className="col-lg-6">
                                <div className="screen-card">
                                    <div className="screen-card-header">
                                        <b>مشخصات</b>
                                        <button onClick={() => setEditModal(true)}>
                                            <ThinEditIcon/>
                                            <span>ویرایش</span>
                                        </button>
                                    </div>
                                    <div className="student-info">
                                        <span>عنوان:</span>
                                        <b>{data.title}</b>
                                        <span>مدرک تحصیلی:</span>
                                        <b>{data.cert}</b>
                                        <span>تعداد مورد نیاز:</span>
                                        <b>{CurrencyFormat(data.needed)}</b>
                                        <span>وضعیت:</span>
                                        <b>{data.isTaken ? 'تکمیل شده' : 'فعال'}</b>
                                        <span>تاریخ ایجاد:</span>
                                        <b>{StringDigitsConvertToPersian(data.createdAt.split(' ')[1] + " " + GregorianToPersian(data.createdAt.split(' ')[0]).replaceAll('-', '/'))}</b>
                                        <span>توضیحات:</span>
                                        <b>
                                            <pre>{data.desc}</pre>
                                        </b>
                                    </div>
                                </div>
                            </div>
                        </div> :
                        <div className="screen-card">
                            <div className="screen-card-header">
                                <b>درخواست ها</b>
                            </div>
                            {
                                signups.map((d, i) =>
                                    <div className="hire-person-card" key={"XzA92_S" + i}>
                                        <div data-sec={"info"}>
                                            <i style={{backgroundImage: `url(${ServerImage(d.photo, 200)})`}}/>
                                            <div>
                                                {!d.reviewed ? <strong>جدید</strong> :
                                                    <strong data-color={"gray"}>بررسی شده</strong>}
                                                <b>{d.name}</b>
                                                <span>{StringDigitsConvertToPersian(d.tell.replaceAll('+98', '0'))}</span>
                                                <div>
                                                    <ThinFamilyLoveIcon/>
                                                    <em>{d.isMarried ? 'متاهل' : 'مجرد'}</em>
                                                </div>
                                                <div>
                                                    <ThinIdCardIcon/>
                                                    <em>سربازی: {HireSoldierStatusToString(d.soldier)}</em>
                                                </div>
                                                <div>
                                                    <ThinCalendarIcon/>
                                                    <em>تولد: {StringDigitsConvertToPersian(GregorianToPersian(d.birthDate.split(' ')[0]).replaceAll('-', '/'))}</em>
                                                </div>
                                                <div>
                                                    <ThinTimeIcon/>
                                                    <em>سال خدمت: {CurrencyFormat(d.yearsActive)}</em>
                                                </div>
                                                {
                                                    d.cv !== '' ?
                                                        <div>
                                                            <ThinDocumentIcon/>
                                                            <a href={Apis.server + `/file/${d.cv}`} target="_blank">مشاهده
                                                                رزومه</a>
                                                        </div> : null
                                                }
                                                {
                                                    d.workNotes.length > 0 ?
                                                        <div>
                                                            <ThinEditNoteIcon/>
                                                            <button onClick={() => setWorkNotesModal({
                                                                show: true,
                                                                note: d.workNotes,
                                                                name: d.name,
                                                            })}>مشاهده زمینه‌های همکاری
                                                            </button>
                                                        </div> : null
                                                }
                                                {
                                                    d.notes.length > 0 ?
                                                        <div>
                                                            <ThinEditNoteIcon/>
                                                            <button onClick={() => setNoteModal({
                                                                show: true,
                                                                note: d.notes,
                                                                name: d.name,
                                                            })}>مشاهده توضیحات
                                                            </button>
                                                        </div> : null
                                                }
                                            </div>
                                        </div>
                                        <div data-sec="actions">
                                            {
                                                !d.reviewed ?
                                                    <button className="open-tooltip"
                                                            onClick={() => setAsReviewed(d.id)}>
                                                        <CheckIcon/>
                                                        <i>بررسی شد</i>
                                                    </button> : null
                                            }
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                }
            </div>
            <AdminsStaffHireAddEditJobModal
                active={editModal}
                closeHandler={() => setEditModal(false)}
                id={jobId as string}
                edit={true}
                onDone={() => {
                    ShowProgressLoading();
                    fetchData();
                }}
            />
            <AdminsHireSignupViewNoteModal
                title={"مشاهده توضیحات " + noteModal.name}
                active={noteModal.show}
                closeHandler={() => setNoteModal(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                name={noteModal.name}
                note={noteModal.note}
            />
            <AdminsHireSignupViewNoteModal
                title={"مشاهده زمینه همکاری " + workNotesModal.name}
                active={workNotesModal.show}
                closeHandler={() => setWorkNotesModal(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                name={workNotesModal.name}
                note={workNotesModal.note}
            />
        </>
    );
};

export const HireSoldierStatusToString = (status: string) => {
    switch (status) {
        case "card":
            return "دارای کارت پایان خدمت";
        case "excuse":
            return "معافیت";
        case "not-gone":
            return "نرفته";
        case "off":
            return "عدم مشمولیت";
        default:
            return "نامشخص";
    }
};